module.exports = "<div class=\"tooltipMessage\" aria-hidden=\"false\" ng-class=\"{'active': $ctrl.show}\">\n  <button type=\"button\" ng-click=\"$ctrl.show=false\" ga-track-event=\"['Tooltip', 'Click', 'Close {{ ($ctrl.name || 'common.help') | translate | escapeSingleQuote }}']\">\n    <span>{{ 'common.close' | translate }}</span>\n  </button>\n  <h5>{{ ($ctrl.name || 'common.help') | translate }}</h5>\n  <p>{{ $ctrl.text | translate }}</p>\n</div>\n<p class=\"mobile\">{{ $ctrl.text | translate }}</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/tooltip/tooltip.html
// module id = 736
// module chunks = 0